module.exports = __webpack_public_path__ + "9bd4e83c393612b2648e38d7a78c7340.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/large-29.png
// module id = 1576
// module chunks = 0